import React, { createContext, useState } from "react";

const LogContent = createContext();

const ContextProvider = ({ children }) => {
  const [displayMeta, setDisplayMeta] = useState(false);

  return (
    <LogContent.Provider value={{ displayMeta, setDisplayMeta }}>
      {children}
    </LogContent.Provider>
  );
};

export { LogContent, ContextProvider };
